import { LoaderContext } from 'context/Context';
import { useState, useCallback, useContext } from 'react';
import { protectedApi } from 'services/axios';

const usePost = params => {
  const { setLoading } = useContext(LoaderContext);
  const { url, payload } = params;
  const [response, setResponse] = useState({
    data: null,
    error: null
  });

  const postRequest = useCallback(() => {
    setLoading(true);
    protectedApi
      .post(url, payload)
      .then(res => {
        setResponse({ data: res.data, error: null });
      })
      .catch(err => setResponse({ data: null, error: err.response }))
      .finally(() => setLoading(false));
  }, [url, JSON.stringify(payload)]);

  return [response, postRequest];
};

export default usePost;
